import { render } from "./VenteChart.vue?vue&type=template&id=5f1746fc"
import script from "./VenteChart.vue?vue&type=script&lang=js"
export * from "./VenteChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__